import styled from 'styled-components';

export const StyledClients = styled.div`

  min-height: 560px;
  background: url(../img/clients1.jpg) no-repeat center center / 100% 100%;
  
  .slick-track {
  display: flex;
  align-items: center;
  }
  
  .slick-dots {

  bottom: -55px;
  li {
  button::before {
  font-size: 12px;
  }
  }
  }
`;

export const StyledContentClients = styled.div`
padding-top: 160px;
`;
